import {ObjectModelPropertyRootType} from "../../../common/enums/objectModelPropertyType";
import assertNever from "../../../global/assetNever";

export default class ObjectModelEntryFieldDefinition {
  static getComponent(propertyType: ObjectModelPropertyRootType) {
    switch (propertyType) {
      case ObjectModelPropertyRootType.Text:
      case ObjectModelPropertyRootType.Number:
        return 'text-input';
      case ObjectModelPropertyRootType.LongText:
        return 'expandable-textarea';
      case ObjectModelPropertyRootType.PickList:
        return 'pick-list-input';
      case ObjectModelPropertyRootType.DateTime:
        return 'date-picker-input';
      case ObjectModelPropertyRootType.MappedProperty:
      case ObjectModelPropertyRootType.RelationshipCount:
      case ObjectModelPropertyRootType.DerivedField:
      case ObjectModelPropertyRootType.AutoIncrement:
      case ObjectModelPropertyRootType.Aggregate:
        return 'read-only-text-input';
      case ObjectModelPropertyRootType.FileAttachment:
        return 'file-input';
      case ObjectModelPropertyRootType.Section:
        return;
      default:
        assertNever(propertyType);
    }
  }

  static showFieldComponent(propertyType: ObjectModelPropertyRootType): boolean {
    switch (propertyType) {
      case ObjectModelPropertyRootType.MappedProperty:
      case ObjectModelPropertyRootType.RelationshipCount:
      case ObjectModelPropertyRootType.DerivedField:
      case ObjectModelPropertyRootType.AutoIncrement:
      case ObjectModelPropertyRootType.Aggregate:
        return false;
      default:
        return true;
    }
  }
}